/**
 * Legal entity and operator information for Female Partner Calculator.
 * Summit Lane Digital, LLC is the umbrella company; Female Partner Calculator is a consumer brand.
 */
export const COMPANY = {
  legalName: 'Summit Lane Digital, LLC',
  brandName: 'Female Partner Calculator',
  formationState: 'Wyoming',
  formationStateAbbr: 'WY',
  website: 'https://femalepartnercalculator.com',
  emails: {
    support: 'support@femalepartnercalculator.com',
    business: 'business@femalepartnercalculator.com',
    privacy: 'privacy@femalepartnercalculator.com',
    legal: 'legal@femalepartnercalculator.com',
    data: 'data@femalepartnercalculator.com',
  },
} as const;

/**
 * Mailing address for legal/privacy correspondence.
 * Update `street` and `city` when Articles of Organization list the Wyoming registered agent street address.
 */
export const COMPANY_MAILING = {
  attn: COMPANY.legalName,
  street: 'c/o Registered Agent',
  city: 'Cheyenne',
  state: COMPANY.formationStateAbbr,
  zip: '',
  country: 'United States',
} as const;

export const BRAND_OPERATOR_LINE =
  `${COMPANY.brandName} is a brand of ${COMPANY.legalName}, a ${COMPANY.formationState} limited liability company.`;

export function formatCompanyMailingAddress(): string {
  const zipSuffix = COMPANY_MAILING.zip ? ` ${COMPANY_MAILING.zip}` : '';
  return `${COMPANY_MAILING.attn}, ${COMPANY_MAILING.street}, ${COMPANY_MAILING.city}, ${COMPANY_MAILING.state}${zipSuffix}, ${COMPANY_MAILING.country}`;
}
